// extracted by mini-css-extract-plugin
export default {"main":"Furnace_main__JNIxX","comingSoon":"Furnace_comingSoon__1ynVh"};